import { flowAsync } from '@gcc/nodash';
import createAndSaveJob from '../_createAndSaveJob';
import prefillAtc from '../_prefillAtc';
import createConfigurationForJob from './_createConfigurationForJob';
import backfillBookJobSucceeded from '../_backfillBookJobSucceeded';
import saveCustomerInfoForShippingPage from './_saveCustomerInfoForShippingPage';
import addBdcJobToCart from './_addBdcJobToCart';
import backfillAtcSucceeded from '../_backfillAtcSucceeded';
import navigateToCart from '../../navigateToCart';
import copyConfigurationsForProductOnly from '../_copyConfigurationsForProductOnly';
import sendAnalytics from './_sendAnalytics';

export default cartingOptions =>
  flowAsync(
    createAndSaveJob,
    prefillAtc,
    createConfigurationForJob, // BDC gets a job configuration
    copyConfigurationsForProductOnly,
    backfillBookJobSucceeded,
    saveCustomerInfoForShippingPage,
    addBdcJobToCart, // cart for BDC
    backfillAtcSucceeded,
    sendAnalytics,
    navigateToCart,
  )(cartingOptions);
